import * as XLSX from "xlsx";

export const exportLeadsToExcel = (data) => {
  // Prepare data for Excel
  const excelData = data.map((row, index) => {
    const createdDate = new Date(row?.createdAt);
    const daysToAdd = row?.country === "UAE" ? 3 : 30;
    const expiryDate = new Date(createdDate);
    expiryDate.setDate(createdDate.getDate() + daysToAdd);

    return {
      "S No": index + 1,
      "Lead Name": row.name || "-",
      Email: row.email || "-",
      Mobile: row.phoneNumber || "-",
      "Company Name": row.companyName || "-",
      Country: row.country || "-",
      "DID No": row.customerCareNo || "-",
      "Subscription Amount": row.subscriptionAmount || 0,
      "Drop Off":
        row.subscriptionStatus === "paid" ? "Paid User" : row.dropoff || "-",
      "Subscription Status": row.subscriptionStatus || "-",
      "Created Date": createdDate.toLocaleDateString("en-GB"),
      "Expiry Date": expiryDate.toLocaleDateString("en-GB"),
      "Account Manager": row.accountManager?.fullName || "Not Assigned",
    };
  });

  // Create workbook and worksheet
  const ws = XLSX.utils.json_to_sheet(excelData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Leads");

  // Auto-fit column widths
  const colWidths = [
    { wch: 8 }, // S No
    { wch: 20 }, // Lead Name
    { wch: 25 }, // Email
    { wch: 15 }, // Mobile
    { wch: 20 }, // Company Name
    { wch: 12 }, // Country
    { wch: 15 }, // DID No
    { wch: 20 }, // Subscription Amount
    { wch: 18 }, // Drop Off
    { wch: 20 }, // Subscription Status
    { wch: 15 }, // Created Date
    { wch: 15 }, // Expiry Date
    { wch: 20 }, // Account Manager
  ];
  ws["!cols"] = colWidths;

  // Style header row
  const headerStyle = {
    fill: { fgColor: { rgb: "667eea" } },
    font: { bold: true, color: { rgb: "FFFFFF" } },
    alignment: { horizontal: "center", vertical: "center" },
  };

  for (
    let col = 0;
    col < excelData[0] ? Object.keys(excelData[0]).length : 0;
    col++
  ) {
    const cellRef = XLSX.utils.encode_cell({ r: 0, c: col });
    if (!ws[cellRef]) ws[cellRef] = {};
    ws[cellRef].s = headerStyle;
  }

  // Generate filename with timestamp
  const timestamp = new Date().toISOString().split("T")[0];
  const fileName = `Leads_Export_${timestamp}.xlsx`;

  // Write file
  XLSX.writeFile(wb, fileName);
};
